import { Row } from "react-grid-system";
import PlaceholderCard from "../../components/placeholders/PlaceholderCard";

const Placeholder = () => (
    <Row>
        {
            Array.from({ length: 6 }).map((_, index) => <PlaceholderCard key={index} />)
        }
    </Row>
);

export default Placeholder;